export default __webpack_public_path__ + "static/media/detailed-flow.baa70706.jpg";